import {Component, Inject} from '@angular/core';

import {AcDialog, DIALOG_CONFIG, DialogConfig} from '../../ac-dialog.models';

@AcDialog({
    id: 'failed-action-dialog',
    title: 'Action Failed',
    cancelButtonText: 'Close',
    formSettings: {valid: true, touched: true},
    width: 450,
    colorPalette: 'red'
})
@Component({
    selector: 'failed-action-dialog',
    templateUrl: './failed-dialog.component.html',
})
export class FailDialogComponent {

    message;

    constructor(@Inject(DIALOG_CONFIG) public dialogConfig: DialogConfig) {
    }

    ngOnInit() {
        this.message =  (typeof this.dialogConfig.dialogData.message === 'string') ? this.dialogConfig.dialogData.message : 'User action failed';
        this.dialogConfig.ready = true;
    }
}


